export const POPULAR_FONTS = [
  "Inter", "Roboto", "Open Sans", "Lato", "Montserrat", "Oswald", "Source Sans Pro", "Slabo 27px", "Raleway", "PT Sans",
  "Merriweather", "Noto Sans", "Playfair Display", "Muli", "Lora", "Kanit", "Arimo", "Crimson Text", "PT Serif", "Titillium Web",
  "Fira Sans", "Quicksand", "Libre Baskerville", "Inconsolata", "Josefin Sans", "Bitter", "Dosis", "Oxygen", "Arvo", "Anton",
  "Lobster", "Dancing Script", "Pacifico", "Shadows Into Light", "Indie Flower", "Bree Serif", "Comfortaa", "Exo 2", "Archivo Narrow", "Play",
  "Ubuntu", "Cormorant Garamond", "Space Mono", "Work Sans", "Spectral", "Karla", "Prompt", "Varela Round", "Cabin", "EB Garamond",
  "Noto Serif Ahom"
].sort();

export const RATIO_OPTIONS = [
  { value: "9:16", label: "Portrait", shape: "portrait" },
  { value: "16:9", label: "Wide", shape: "wide" },
  { value: "1:1", label: "Square", shape: "square" },
  { value: "4:5", label: "Social", shape: "social" },
] as const;

export const DEFAULT_CONFIG = {
  text: '',
  durationStr: '00:10',
  aspectRatio: '9:16',
  textColor: '#ffffff',
  backgroundColor: '#000000',
  backgroundImage: '',
  backgroundVideoUrl: '',
  fontName: 'Inter',
  fontSize: 48,
  textAlign: 'center' as const,
  lineHeight: 1.2,
  textShadow: 0,
  blur: 0,
  vignette: 0,
  renderMode: 'classic' as const,
  audio: {
    voiceoverVolume: 1,
    musicVolume: 0.5,
    duckingAmount: 0.8,
  },
  segments: [],
};
